import type { EditorState } from '#packages/stateManagement';
import { EditorTypeOptions } from '@wix/ambassador-editor-branches-v1-branch/types';

const getCurrentBranchName = (state: EditorState): string =>
  state.branches.currentBranchName;

const getWasBranchesListFetched = (state: EditorState): boolean =>
  state.branches.wasBranchesListFetched;

const getHasBranches = (state: EditorState): boolean =>
  !!state.branches.hasBranches;

const getDsHasPublishedStudioBranch = (state: EditorState): boolean => {
  const branches = state.branches.dsBranchesList;
  const publishedBranchId = state.branches.dsPublishedBranchId;
  if (!branches || !publishedBranchId) {
    return false;
  }
  const publishedBranch = branches.find((b) => b.id === publishedBranchId);
  return (
    publishedBranch?.editorType?.editorTypeOptions === EditorTypeOptions.STUDIO
  );
};

export {
  getCurrentBranchName,
  getWasBranchesListFetched,
  getHasBranches,
  getDsHasPublishedStudioBranch,
};
